import React, {useEffect, useState} from "react";

import './recording-charts.scss'
import {useRecoilValue} from "recoil";
import {grpcCustomerServiceSelector} from "../../state/grpc";
import {DonutChart} from "@carbon/charts-react";
import PropTypes from "prop-types";
import moment from "moment/moment";

const RecordingOperatorDonut = ({dateRef}) => {
  const systemService = useRecoilValue(grpcCustomerServiceSelector)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)
  const [stats, setStats] = useState([])

  useEffect(() => {
    const req = new proto.api.GetRecordingsStatsRequest()
    req.setFromDate(moment(dateRef).startOf("day").startOf("month").format("DD/MM/YYYY hh:mm:ss"))
    req.setToDate(moment(dateRef).endOf("day").endOf("month").format("DD/MM/YYYY hh:mm:ss"))
    systemService.getRecordingsStats(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        setError(true)
      } else {
        const stats = resp.toObject().recordingstatsList.map((entry) => {
          return {
            group: entry.username,
            count: Number(entry.durationminutes)
          }
        })
        setStats(stats)
      }
      setLoading(false)
    })
  }, [dateRef]);

  const options = {
    title: 'Rendicontazioni operatori',
    resizable: true,
    legend: {
      alignment: 'center'
    },
    pie: {
      valueMapsTo: 'count'
    },
    data: {
      loading: loading || error,
    },
    donut: {
      center: {
        label: 'Minuti'
      },
      alignment: 'center'
    },
    height: '400px'
  }

  return (
    <DonutChart
      data={stats}
      options={options}
    />
  )
}

RecordingOperatorDonut.propTypes = {
  dateRef: PropTypes.object.isRequired,
}

export default RecordingOperatorDonut